import SaveIcon from "assets/icon/SaveIcon"

export default function SaveButton(props){
    return(
        <button className={`button flex gap-2 
            ${ props?.visible ? 'block' : 'hidden' } 
            ${ props?.disabled ? 'opacity-50 cursor-not-allowed' : '' } 
            `} 
            onClick={props?.onClick} disabled={props?.disabled}
        >
            <SaveIcon className="fill-white w-6" />
            <span>Save</span>
        </button>
    )
}